exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.toggle-container[data-v-20661d9c]{\n}\n.toggle-control[data-v-20661d9c]{\n  cursor: pointer;\n}\n.toggle-control[data-v-20661d9c] :hover{\n  opacity: 80%;\n}\n.switch-on[data-v-20661d9c]{\n  color: royalblue;\n}\n.switch-off[data-v-20661d9c]{\n  color: slategray;\n}\n\n\n", ""]);

// exports
